import React from 'react';
// import store from '../../../../../stores/store';
import memberPlaceholder from '../../../../../assets/images/member_placeholder.svg';

function buildEmail(emailAddress) {
    if (emailAddress) {
        return (
            <div className="">
                <i
                    className="fa fa-envelope-o text-muted attendee-contact-icon-padding"
                    aria-hidden="true"
                />
                <a className="mail-link" href={`mailto:${emailAddress}`}>{emailAddress}</a>
            </div>
        );
    }
}

function buildPhone(phone1) {
    if (phone1) {
        return (
            <div className="">
                <i
                    className="fa fa-phone text-muted attendee-contact-icon-padding"
                    aria-hidden="true"
                />
                {phone1}
            </div>
        );
    }
}

export const MemberCard = props => {
    const detail = props.detail;

    return (
        <div className="col-xs-12 col-lg-6 col-xl-4 p-1">
            <div className="card h-100 w-100">
                <div className="card-block d-flex flex-column align-items-start">
                    <div className="d-flex flex-wrap">
                        <div className="p-2">
                            {detail.localAvatarUrl !== undefined ? (
                                <img
                                    src={detail.localAvatarUrl}
                                    alt="User"
                                    className="rounded-circle img-fluid mx-auto d-block user-pic-menu"
                                />
                            ) : (
                                <img
                                    src={memberPlaceholder}
                                    alt="User"
                                    className="rounded-circle img-fluid mx-auto d-block user-pic-menu"
                                />
                            )}
                        </div>
                        <div className="p-2">
                            <h6 className="mb-0">
                                {detail.FirstName} {detail.Surname}
                            </h6>
                            <small>
                                {detail.MemberTypeName
                                    ? detail.MemberTypeName
                                    : detail.Title ? detail.Title : ''}
                            </small>
                            <div className="card-text">
                                {buildPhone(detail.Phone1)}{buildPhone(detail.Phone2)}
                                {buildEmail(detail.EmailAddress)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Dashboard/components/Member/MemberCard.js